import { createIcon } from './createIcon';

const Map = createIcon(
  'Map',
  <>
    <path
      d="M3 7L9 4L15 7L21 4V17L15 20L9 17L3 20V7Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9 4V17" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 7V20" strokeLinecap="round" strokeLinejoin="round" />
  </>,
);

export default Map;
